export class Deferred<TData = unknown, TError = unknown> {
    private _resolve?: (value?: TData) => void;
    private _reject?: (reason?: TError) => void;
    private _promise: Promise<TData>;
    constructor() {
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve as (value?: TData) => void;
            this._reject = reject as (reason?: TError) => void;
        });
    }
    get promise() {
        return this._promise;
    }
    resolve(value?: TData) {
        this._resolve?.(value);
    }
    reject(reason?: TError) {
        this._reject?.(reason);
    }
}
